import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ContentSection() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-10">
          <div className="flex items-start gap-5">
            <div className="hidden sm:flex w-14 h-14 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className="ri-file-text-line text-2xl"></i>
            </div>
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">{t("content.title")}</h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-4">{t("content.p1")}</p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-3">{t("content.p2")}</p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-3">{t("content.p3")}</p>

              <Link
                to="/allchinabuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                {t("content.linkLabel")}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}